import React from 'react';
import { StoreVisitScreenDesktop } from './StoreVisitScreenDesktop';
import { StoreVisitScreenMobile } from './StoreVisitScreenMobile';

export const StoreVisitScreen = () => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <StoreVisitScreenMobile /> : <StoreVisitScreenDesktop />;
};